import { BlockComponent } from 'lib'
import { Callback } from 'types/index'
import { useBinaryAnimation } from 'components/patterns/icons/animation/hooks/binaryAnimation'
import { RotationAnimation } from 'components/patterns/icons/animation/elements/rotate'
import { BASE_INTERACTION_DURATION } from 'components/patterns/icons/animation/constants'
import { IconButton } from 'components/patterns/icons/blocks/IconButton'

interface Props {
	value: boolean
	onChange?: Callback<boolean>
}

/**
 * An Icon that can be used to trigger the Expanding or Collapsing of an element and  animate between the states.
 * @param {boolean} value The state of the expanded component
 * @param {(args: boolean) => void} onChange A callback for when the icon is clicked containing the current state
 * @constructor
 */
export const ExpandIcon: BlockComponent<Props> = ({ value }) => {
	const [triggerExpand, triggerCollapse] = useBinaryAnimation(value)

	return (
		<IconButton type="button" aria-label={value ? 'Expand' : 'Collapse'} aria-pressed={value}>
			<svg
				viewBox="0 0 24 24"
				width="100%"
				height="100%"
				preserveAspectRatio="xMidYMid meet"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g strokeWidth="3.5" stroke="currentColor" strokeLinecap="round">
					<path d="M2 12 H 22" />
					<line x1="12" y1="2" y2="22" x2="12">
						<RotationAnimation
							fromΘ={0}
							toΘ={90}
							duration={BASE_INTERACTION_DURATION}
							origin="12 12"
							ref={triggerExpand}
						/>
						<RotationAnimation
							fromΘ={90}
							toΘ={0}
							duration={BASE_INTERACTION_DURATION}
							origin="12 12"
							ref={triggerCollapse}
						/>
					</line>
				</g>
			</svg>
		</IconButton>
	)
}
